import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProductPrice } from '../_models/product-price';
import { Product } from '../_models/product';
import { Globals } from '../globals';
import { ProductService } from '../_services/product.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConstantsService } from '../_services/constants.service';

@Component({
  selector: 'app-country-pricing-collapsible',
  templateUrl: './country-pricing-collapsible.component.html',
  styleUrls: ['./country-pricing-collapsible.component.scss'],
})
export class CountryPricingCollapsibleComponent implements OnInit {
  @Input() public price: ProductPrice;
  @Input() public product: Product;
  @Output() public refresh = new EventEmitter();
  public origins: string[] = [];

  constructor(public globals: Globals, private productService: ProductService, private snackBar: MatSnackBar, private constantsService: ConstantsService) { }

  public ngOnInit(): void {
    this.constantsService.getOrigins().subscribe({
      next: (constants) => {
        this.origins = constants;
      },
      error: (err) => {
        console.error(err);
      }, complete: null
    });
  }

  public refreshProductView() {
    this.refresh.emit('');
  }

  public saveProductPrice(price: ProductPrice) {
    if (!price.ProductId) {
      price.ProductId = this.product.Id;
    }
    if (!this.isValid()) {
      return;
    }
    this.productService.saveProductPrice(price).subscribe(
      (resultPrice) => {
        this.refresh.emit(resultPrice);
      },
      (error) => {
        console.error(error);
      },
    );
  }

  public deleteProductPrice(price: ProductPrice) {
    if (!price.ProductId) {
      price.ProductId = this.product.Id;
    }
    if (!this.isValid()) {
      return;
    }
    this.productService.deleteProductPrice(price).subscribe(
      (resultPrice) => {
        console.log(resultPrice);
        this.refresh.emit(resultPrice);
      },
      (error) => {
        console.error(error);
      },
    );
  }

  private isValid() {
    const snackBarConfig = { duration: 2000 };
    // console.log(this.price.CountryId);
    // if (!this.price.CountryId || this.price.CountryId <= 0) {
    //   this.snackBar.open('Please select a country.', 'Error', snackBarConfig);
    //   return false;
    // }
    if (this.price.Price <= 0) {
      this.snackBar.open('Please enter a price.', 'Error', snackBarConfig);
      return false;
    }

    return true;
  }
}
